import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, Renderer2, Input } from '@angular/core';
import { LanguageApp } from 'src/app/config/datatable-config';
import Swal from 'sweetalert2';
import { Helpers } from 'src/app/helpers/helpers';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { AmazonCardService } from 'src/app/services/amazon-card.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { ToastrService } from 'ngx-toastr';
import { AmazonCardType } from 'src/app/helpers/enum';

@Component({
  selector: 'animation-amazon-card',
  templateUrl: './animation-amazon-card.component.html',
  styleUrls: ['./animation-amazon-card.component.scss'],
})
export class AnimationAmazonCardComponent
  implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  listenerFn!: () => void;
  @Input() Type;

  constructor(
    private service: AmazonCardService,
    private helper: Helpers,
    private renderer: Renderer2,
    private clipboard: Clipboard,
    private toastr: ToastrService
  ) { }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
    this.helper.setDataTableSearchDelay();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.draw();
    });
  }

  ngOnInit(): void {
    this.setDatatable();

    this.listenerFn = this.renderer.listen('document', 'click', (event) => {
      if (event.target.hasAttribute("data-amz-code")) {
        this.copyCode(event.target.getAttribute("data-amz-code"));
      }
    });
  }

  setDatatable() {
    const that = this;
    this.dtOptions = {
      responsive: true,
      paging: true,
      pageLength: 10,
      ordering: false,
      lengthChange: true,
      info: false,
      serverSide: true,
      processing: true,
      language: LanguageApp.spanish_datatables,
      dom: LanguageApp.custom_dom_datatables,
      ajax: (dataTablesParameters: any, callback) => {
        that.service.getDataTable(dataTablesParameters, this.Type).subscribe(resp => {
          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: resp.data
          });
        }, (err) => {
          Swal.fire({
            icon: 'error',
            title: 'Error al recuperar los datos',
            text: 'Ocurrió un error',
            buttonsStyling: false,
            customClass: {
              confirmButton: 'btn btn-outline-secondary'
            },
            confirmButtonText: 'Cerrar'
          });

        });
      },
      drawCallback: function () {
        that.helper.enableBsTooltips();
      },
      columns: [
        { data: "CreationDate" },
        { data: "Title", className: "text-start" },
        { data: "Code", className: "text-start" },
        { data: "Value" }
      ],
      columnDefs: [
        {
          targets: [2],
          data: "Code",
          className: "align-middle text-center",
          render: function (data, type, full) {
            var retorno = data;
            retorno += '<button class="btn-option btn-option-outline btn-option-copy ms-2" data-amz-code="' + data + '" title="Copiar código"><span class="visually-hidden">Copiar código</span></button>';
            return retorno;
          }
        },
        {
          targets: [3],
          data: "Value",
          className: "align-middle text-center",
          render: function (data, type, full) {
            var retorno = data + '€';
            return retorno;
          }
        }
      ]
    };
  }

  copyCode(code) {
    this.clipboard.copy(code);
    this.toastr.success("Código copiado al portapapeles");
  }
}
